import apiClient from "../../../utilities/apiClient";

export const getProjectLists = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.project_list}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true,
  );
};

export const createProject = (payload) => {
  return apiClient.post(`${apiClient.Urls.create_project}`, payload, true);
};

export const deleteProject = (payload) => {
  return apiClient.delete(
    `${apiClient.Urls.delete_project}/${payload?.id}`,
    {},
    true,
  );
};

export const updateProjectStatus = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.update_project_status}/${payload?.id}`,
    { isActive: payload?.isActive },
    true,
  );
};

export const getProjectById = (id) => {
  return apiClient.get(`${apiClient.Urls.get_project_by_id}/${id}`, {}, true);
};

export const getProjectUsers = async (companyId, projectId) => {
  const { data } = await apiClient.get(
    `${apiClient.Urls.get_project_users}/${companyId}/${projectId}`,
    {},
    true,
  );
  return data;
};

export const projectToItemRequisition = (payload) => {
  return apiClient.post(
    apiClient.Urls.project_to_item_requisition,
    payload,
    true,
  );
};

export const getCompanyBusinessUnits = (companyId) => {
  return apiClient.get(
    `${apiClient.Urls.get_company_business_units}/${companyId}`,
    {},
    true,
  );
};

export const getProjectItems = (projectId) => {
  return apiClient.get(
    `${apiClient.Urls.project_to_item_requisition_items}/${projectId}/items`,
    {},
    true,
  );
};

export const getProjectWorkflows = () => {
  return apiClient.get(apiClient.Urls.get_project_workflows, {}, true);
};

export const triggerProjectWorkflow = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.trigger_project_workflow}/${payload.projectId}/submit-to-workflow`,
    { workflow_id: payload.workflowId },
    true,
  );
};

export const approveProjectWorkflow = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.project_workflow_status_update}/${payload.projectId}/status`,
    { is_approved: true, is_rejected: false, reason: "" },
    true,
  );
};

export const rejectProjectWorkflow = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.project_workflow_status_update}/${payload.projectId}/status`,
    { is_approved: false, is_rejected: true, reason: payload.reason },
    true,
  );
};
